import { PaginationResponse } from "../../../../model/base/response/pagination-response";
import { IListClientsRequest } from "../../../../model/base/request/list-clients-request";
import { IListClientsResponse } from "../../../../model/base/response/list-clients-response";
import { IClientDetailResponse } from "../../../../model/base/response/client-detail-response";
import { ICreateClientRequest } from "../../../../model/base/request/create-client-request";
import { IListStateResponse } from "../../../../model/base/response/list-state-response";
import { IListCityResponse } from "../../../../model/base/response/list-city-response";

export type ClientsManagementState = {
    brandLogo: File | null;
    clientsPagedRequest: IListClientsRequest;
    clientsPagedResponse: PaginationResponse<IListClientsResponse>;
    selectedClient: IClientDetailResponse | null;
    isLoadingData: boolean;
    isLoadingClient: boolean;
    isDrawerOpen: boolean;
    isEditing: boolean;
    clientForm: ICreateClientRequest;
    listStateResponse: IListStateResponse[];
    listCityResponse: IListCityResponse[];
};

export enum ACTION_TYPES {
    setClientsPagedRequest = 'setClientsPagedRequest',
    setClientsPagedResponse = 'setClientsPagedResponse',
    setSelectedClient = 'setSelectedClient',
    setIsLoadingData = 'setIsLoadingData',
    setIsLoadingClient = 'setIsLoadingClient',
    setIsDrawerOpen = 'setIsDrawerOpen',
    setIsEditing = 'setIsEditing',
    setClientForm = 'setClientForm',
    resetClientForm = 'resetClientForm',
    setListStateResponse = 'setListStateResponse',
    setListCityResponse = 'setListCityResponse',
    setBrandLogo = 'setBrandLogo',
}

export const ClientsManagementReducer = (state: ClientsManagementState, action: any): ClientsManagementState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setClientsPagedRequest:
            return {
                ...state,
                clientsPagedRequest: payload,
            };
        case ACTION_TYPES.setClientsPagedResponse:
            return {
                ...state,
                clientsPagedResponse: payload,
            };
        case ACTION_TYPES.setSelectedClient:
            return {
                ...state,
                selectedClient: payload,
            };
        case ACTION_TYPES.setIsLoadingData:
            return {
                ...state,
                isLoadingData: payload,
            };
        case ACTION_TYPES.setIsLoadingClient:
            return {
                ...state,
                isLoadingClient: payload,
            };
        case ACTION_TYPES.setIsDrawerOpen:
            return {
                ...state,
                isDrawerOpen: payload,
            };
        case ACTION_TYPES.setIsEditing:
            return {
                ...state,
                isEditing: payload,
            };
        case ACTION_TYPES.setClientForm:
            return {
                ...state,
                clientForm: payload,
            };
        case ACTION_TYPES.setBrandLogo:
            return {
                ...state,
                brandLogo: payload,
            };
        case ACTION_TYPES.resetClientForm:
            return {
                ...state,
                clientForm: {
                    entityType: 0,
                    address: {
                        cityId: 0
                    }
                } as ICreateClientRequest,
            };
        case ACTION_TYPES.setListStateResponse:
            return {
                ...state,
                listStateResponse: payload,
            };
        case ACTION_TYPES.setListCityResponse:
            return {
                ...state,
                listCityResponse: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}